import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { SharedHttp } from '../../services/http-client.service';
/**
 * Modal Component
 */
let SlipModalComponent = class SlipModalComponent {
    constructor(sanitizer, themeService, webSettingsService, httpClient, domSanitizer) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.httpClient = httpClient;
        this.domSanitizer = domSanitizer;
        this.borderRadiusSmaller = '';
        this.currentError = null;
        this.errorColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
    }
    ngOnInit() {
        this.orderId = this.data.order_id;
        if (this.orderId) {
            this.response = null;
            this.httpClient.post('market/order/getpaymentslip', {
                order_id: this.orderId
            }).subscribe((result) => {
                this.response = result;
                this.b64ImgUrl = (typeof this.response['ips_qr'] !== 'undefined' && this.response['ips_qr'] !== null && this.response['ips_qr'].b64data !== null) ?
                    this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.response['ips_qr'].b64data) : '';
            }, rsp => {
                this.response = null;
                this.currentError = rsp.error.message;
            });
        }
    }
    close() {
        this.modal.destroy();
    }
};
SlipModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: SharedHttp },
    { type: DomSanitizer }
];
SlipModalComponent = __decorate([
    Component({
        selector: 'ecd-slip',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./slip-modal.component.html")).default
    })
], SlipModalComponent);
export { SlipModalComponent };
